import WordPressLogin from "./components/login";
import "./styles.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import PWAPrompt from 'react-ios-pwa-prompt'
import Dashboard from "./components/Dashboard/Dashboard";
import WastageCalculator from "./components/WastageCalculator/WastageCalculator";
import Carousel from "./components/Carousel/Carousel";


const elementExists = (selector) => {
  return document.querySelector(selector) !== null;
};

const renderReactElement = (element, containerSelector) => {
  console.log("renderReactElement");
  // Does the container element exist?
  if (!elementExists(containerSelector)) {
    return;
  }

  // Get the container element
  const allContainers = document.querySelectorAll(containerSelector);
  // Does the container element exist?
  if (allContainers.length > 0) {
    allContainers.forEach((container) => {
      //ReactDOM.render(element, container);
      ReactDOM.createRoot(container).render(element);
    });
  }
};


renderReactElement(<WordPressLogin />, "#wp-react-login")
renderReactElement(<Dashboard />, "#app-dashboard")
renderReactElement(<WastageCalculator />, "#wastage-calculator")
renderReactElement(<Carousel items={
  [
    <div className="carousel-item">1</div>,
    <div className="carousel-item">2</div>,
    <div className="carousel-item">3</div>,
    <div className="carousel-item">4</div>,
    <div className="carousel-item">5</div>,
    <div className="carousel-item">6</div>,
  ]
} />, "#courses-carousel")

// Add <PWAPrompt /> to the page after injecting a div at the end of the body
const pwaPrompt = document.createElement("div");
pwaPrompt.id = "pwa-prompt";
document.body.appendChild(pwaPrompt);
// renderReactElement(<PWAPrompt />, "#pwa-prompt");

